<template>
  <ssl-certificates-list />
</template>

<script>
import SslCertificatesList from '@/components/Ssl/SslCertificatesList'

export default {
  name: 'SslCertificates',
  components: {
    SslCertificatesList,
  }
}
</script>
